import React from 'react';
import { motion } from 'framer-motion';
import { useCampaigns } from '../../contexts/CampaignContext';
import SafeIcon from '../../common/SafeIcon';
import { FiEye, FiMail, FiMousePointer, FiTrendingUp } from 'react-icons/fi';


const CampaignOverview = () => {
  const { getRecentCampaigns } = useCampaigns();
  const recentCampaigns = getRecentCampaigns(3);

  const metrics = [
    { label: 'Open Rate', value: '24.5%', icon: FiEye, trend: '+2.1%' },
    { label: 'Click Rate', value: '3.8%', icon: FiMousePointer, trend: '+0.5%' },
    { label: 'Response Rate', value: '1.2%', icon: FiMail, trend: '+0.3%' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Campaign Overview</h3>
        <SafeIcon icon={FiTrendingUp} className="text-gray-400" />
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.label}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            className="text-center p-3 bg-gray-50 rounded-lg"
          >
            <SafeIcon icon={metric.icon} className="text-gray-400 mx-auto mb-1" />
            <p className="text-lg font-semibold text-gray-900">{metric.value}</p>
            <p className="text-xs text-gray-500">{metric.label}</p>
            <p className="text-xs text-green-600 font-medium">{metric.trend}</p>
          </motion.div>
        ))}
      </div>

      {/* Recent Campaigns */}
      <div>
        <h4 className="text-sm font-medium text-gray-900 mb-3">Recent Campaigns</h4>
        {recentCampaigns.length > 0 ? (
          <div className="space-y-3">
            {recentCampaigns.map((campaign, index) => (
              <motion.div
                key={campaign.id}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="text-sm font-medium text-gray-900">{campaign.name}</p>
                  <p className="text-xs text-gray-500">{campaign.type} Campaign</p>
                </div>
                <div className="text-right">
                  <span className={`inline-block px-2 py-1 text-xs rounded-full ${
                    campaign.status === 'active' ? 'bg-green-100 text-green-800' :
                    campaign.status === 'draft' ? 'bg-gray-100 text-gray-800' :
                    'bg-blue-100 text-blue-800'
                  }`}>
                    {campaign.status}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <SafeIcon icon={FiMail} className="text-gray-300 text-3xl mx-auto mb-2" />
            <p className="text-sm text-gray-500">No campaigns yet</p>
            <p className="text-xs text-gray-400">Create your first campaign to get started</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignOverview;